import type { QueryClient } from '@tanstack/react-query';
import { notFound, redirect } from '@tanstack/react-router';
import { getVisualizationViewsQueryOptions } from 'src/lib/queries/view/useVisualizationsView';
import { getLastVisitedView } from './lastVisitedVisualizationView';

export async function redirectToFirstLoopVisualizationView({
  org,
  queryClient,
  loopId, //Temporarily ignore loopId until we have loop views db ready
}: {
  org: string;
  queryClient: QueryClient;
  loopId: number;
}): Promise<void> {
  if (!loopId) throw notFound();

  const views = await queryClient.ensureQueryData(
    getVisualizationViewsQueryOptions({
      org,
      loopId,
    }),
  );

  const lastVisitedViewId = getLastVisitedView(loopId);
  const targetView =
    (lastVisitedViewId ? views.find((v) => v.viewId === lastVisitedViewId) : undefined) ?? views[0];

  // Redirect to target view if any exist
  if (targetView) {
    throw redirect({
      to: `/org/$org/loop/$loopId/visualizations/view/$viewId`,
      params: { org, loopId, viewId: targetView.viewId },
      replace: true,
    });
  }
}
